import { useMemo } from 'react';
import { INSURANCE_TYPES_NAMES } from 'constants/insurance-types-names';
import usePolicyOptions from 'hooks/usePolicyOptions';
import { IPolicy } from 'types';
import {
  getLifeDetailsFields,
  getDefaultDetailsFields,
  getHomeContentsFields,
  getPayoutFields,
  getTravelFields,
  getPetFields,
  getQ4eFields,
  getVehicleFields,
  getMbiFields,
} from './utils';

const getFieldsWithOptions = (policy: IPolicy, options) => {
  if (policy.employerId) {
    return getQ4eFields(policy, options);
  }

  switch (policy.policyType) {
    case INSURANCE_TYPES_NAMES.HOME_CONTENTS:
    case INSURANCE_TYPES_NAMES.LANDLORD:
      return getHomeContentsFields(policy, options);
    case INSURANCE_TYPES_NAMES.MORTGAGE:
    case INSURANCE_TYPES_NAMES.INCOME:
      return getPayoutFields(policy, options);
    case INSURANCE_TYPES_NAMES.LIFE:
      return getLifeDetailsFields(policy, options);
    case INSURANCE_TYPES_NAMES.TRAVEL:
      return getTravelFields(policy, options);
    case INSURANCE_TYPES_NAMES.PET:
      return getPetFields(policy, options);
    case INSURANCE_TYPES_NAMES.VEHICLE:
      return getVehicleFields(policy, options);
    case INSURANCE_TYPES_NAMES.MBI:
      return getMbiFields(policy, options);
    default:
      return getDefaultDetailsFields(policy, options);
  }
};

const usePolicyDetails = (policy: IPolicy) => {
  const { options, loading } = usePolicyOptions(policy);

  const fields = useMemo(() => getFieldsWithOptions(policy, options), [
    policy,
    options,
  ]);

  return {
    fields,
    loading,
    options,
  };
};

export default usePolicyDetails;
